/**
 * SEO Constants and Utilities
 *
 * Central place for SEO-related constants used across the application.
 * Keeps canonical URLs, site metadata, and structured data helpers DRY.
 */

export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://www.eventfinder.site').replace(/\/+$/, '');
export const SITE_NAME = 'Event Finder';
export const SITE_DESCRIPTION = 'AI-powered event discovery platform helping users find conferences, workshops, training sessions, and networking events worldwide.';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/EFlogo.png`;

/**
 * Build a canonical URL from a route path.
 * Strips trailing slashes for consistency (except root "/").
 */
export const canonicalUrl = (path: string): string => {
  const canonical = new URL(path, `${SITE_URL}/`);
  canonical.pathname = canonical.pathname === '/' ? '/' : canonical.pathname.replace(/\/+$/, '');
  canonical.hash = '';
  for (const key of Array.from(canonical.searchParams.keys())) {
    if (/^(utm_.+|gclid|dclid|fbclid|msclkid|gbraid|wbraid|gad_source|gad_campaignid)$/i.test(key)) {
      canonical.searchParams.delete(key);
    }
  }
  canonical.searchParams.sort();
  return canonical.href;
};

/**
 * Truncate a description to a safe meta description length (≤160 chars).
 * Breaks at the last word boundary before the limit.
 */
export const truncateDescription = (text: string, maxLength = 160): string => {
  if (!text || text.length <= maxLength) return text;
  const truncated = text.slice(0, maxLength);
  const lastSpace = truncated.lastIndexOf(' ');
  return lastSpace > 0 ? truncated.slice(0, lastSpace) + '…' : truncated + '…';
};
